/**
 * Infinite Carousel Fix
 */
document.addEventListener("DOMContentLoaded", function() {
  const carousels = document.querySelectorAll("slider-grid[autoplay-mode=\"seamless\"]");
  carousels.forEach(carousel => {
    const originalRestart = carousel.restartSeamlessAutoplay;
    if (originalRestart) {
      carousel.restartSeamlessAutoplay = function() {
        const track = this.querySelector(".slider-grid-track");
        if (!track) return;
        track.style.transition = "none";
        track.style.removeProperty("transform");
        void track.offsetWidth;
        track.style.transition = "";
        setTimeout(() => {
          if (this.initAutoplay) this.initAutoplay();
        }, 50);
      };
    }
  });
});
